import * as tslib_1 from "tslib";
import { SvgIcon } from '@nextiva/next-ui';
import cx from 'classnames';
import React from 'react';
import Styles from "./OptionsList.css";

var OptionsList =
/** @class */
function (_super) {
  tslib_1.__extends(OptionsList, _super);

  function OptionsList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getFormattedTitle = function (title) {
      return [title.substr(0, 1).toUpperCase(), title.substr(1).toLowerCase()].join('');
    };

    _this.getActive = function (option, i) {
      var _a = _this.props,
          value = _a.value,
          fixedIcon = _a.fixedIcon;

      if (fixedIcon) {
        return false;
      } else {
        return option === value || !value && i === 0;
      }
    };

    return _this;
  }

  OptionsList.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        options = _a.options,
        getIconSrc = _a.getIconSrc,
        onSelect = _a.onSelect;
    return React.createElement("div", {
      className: Styles.options,
      "data-test": "popover-options-list"
    }, options.map(function (option, i) {
      var _a;

      var title = _this.getFormattedTitle(option.label);

      var onClick = function onClick() {
        return onSelect(option);
      };

      var svgSrc = option.icon ? getIconSrc(option.icon) : null;

      var isActive = _this.getActive(option, i);

      var className = cx(Styles.option, (_a = {}, _a[Styles.active] = isActive, _a));
      return React.createElement("div", {
        key: i,
        className: className,
        onClick: onClick,
        "data-test-is-active": isActive
      }, React.createElement("div", {
        className: Styles.optionTitle
      }, title), svgSrc && React.createElement(SvgIcon, {
        className: Styles.optionIcon,
        src: svgSrc
      }));
    }));
  };

  OptionsList.defaultProps = {
    options: [],
    onSelect: function onSelect() {},
    getIconSrc: function getIconSrc() {
      return '';
    }
  };
  return OptionsList;
}(React.PureComponent);

export default OptionsList;